import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-crud-imagenes',
  templateUrl: './crud-imagenes.component.html',
  styleUrls: ['./crud-imagenes.component.css']
})
export class CrudImagenesComponent implements OnInit {

  @Input() imagenes     : any;
  @Input() itemequipoid : any;
  @Input() modalId      : any;

  @Output() guardarImagen   = new EventEmitter<any>();
  @Output() eliminarImagen  = new EventEmitter<any>();

  dataImagenes      :any = [];
  dataarchivo       :any = [];
  intervaloTiempo   :number = 2000; // Valor del intervalo del slider
  activarSlideIndex = 0; //Indice de activacion del slider
  noPause           = false; //Variable para pausar o no con onMouse el movimiento del slider
  modalRef          : BsModalRef; //Ventana modal

  constructor(
    private toastr        : ToastrService,
    private modalService  : BsModalService,
  ) { }

  ngOnInit() {
    
  }

  abrirModal(template) {
    this.modalRef = this.modalService.show(template, {backdrop:'static', keyboard:false, class: 'gray modal-lg'});
  }

  agregarImagen() {
    document.getElementById('gestionFileImage').click();
  }

  cargarImagen(evento) {
    const pattern = /image-*/;
    this.dataarchivo = [];
    this.dataImagenes = [];
    
    const limit = 1024; //Limite de subida del archivo
    const limiteCarga = 2048; //Limite de subida del archivo para subir a la web
    
    for (let i = 0; i < evento.target.files.length; i++) {
      const name = evento.target.files[i].name;
      const type = evento.target.files[i].type;
      const size = parseInt(evento.target.files[i].size);

      //Validación formato imagen
      if (!type.match(pattern)) {
        this.toastr.error('Formato de imagen invalido *', 'Error', { timeOut: 3000 });
        return;
      }

      const sizekiloByte = size/limit;
      //Validacion en caso que los archivos excedan tamaño
      if (sizekiloByte > limiteCarga) {
        return this.toastr.error("El Archivo " + name + ' no puede superar a las dos megas.', 'Error', { timeOut: 3000 });
      }

      //Se recogen los datos de la imagen
      const file = evento.target.files[i];
      if (file != undefined){
        this.extraerBase64(file).then( imagen => {
          this.dataImagenes.push({
            'name'        : name,
            'type'        : type,
            'size'        : size,
            'fotoitem'    : '1',
            'itemequipoid': this.itemequipoid,
            'archivo'     : imagen
          });
        })
      }
    }
  }

  onGuardarImagen() {
    let data = {
      'dataarchivo' : this.dataImagenes
    }
    this.guardarImagen.emit(data);
    this.dataImagenes = [];
  }

  cancelar() {
    this.dataImagenes = [];
  }

  onEliminarImagen(imagen) {
    this.eliminarImagen.emit(imagen);
    this.dataImagenes = [];
  }

  cerraModal() {
    this.dataImagenes = [];
  }

  extraerBase64 = async ($event: any) => new Promise((resolve, refect) => {
    try {
      const reader = new FileReader();
      reader.readAsDataURL($event);        
      reader.onload = () => {
        resolve(reader.result);
      }
    } catch {}
  })

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/crud-imagenes/crud-imagenes.component.ts